import { Directive, EventEmitter, Injectable, Input, Output, ViewChild, } from '@angular/core';
import { TemplateUuids } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
const _c0 = ["input"];
export class ToggleableInputDirective {
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this._checked = false;
        this._disabled = false;
        this.templateUuids = new TemplateUuids();
        this._indeterminate = false;
        this._value = null;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onChangeCallback = (_) => { };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onTouchedCallback = () => { };
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._checked = value;
        this._inputElement.nativeElement.checked = value;
        this._changeDetectorRef.markForCheck();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = !!value;
    }
    get indeterminate() {
        return this._indeterminate;
    }
    set indeterminate(value) {
        this._indeterminate = value ? true : false;
        this._inputElement.nativeElement.indeterminate = this._indeterminate;
        this._changeDetectorRef.markForCheck();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this.value !== value) {
            this._value = value;
        }
    }
    _onChangeEvent(event) {
        event.stopPropagation();
        this.checked = this._inputElement.nativeElement.checked;
        this.change.emit(this.checked);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetectorRef.markForCheck();
    }
    writeValue(val) {
        if (val !== this.value) {
            this.value = val;
        }
    }
}
ToggleableInputDirective.ɵfac = function ToggleableInputDirective_Factory(t) { return new (t || ToggleableInputDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ToggleableInputDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ToggleableInputDirective, viewQuery: function ToggleableInputDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
    } }, inputs: { checked: "checked", disabled: "disabled", indeterminate: "indeterminate", value: "value" }, outputs: { change: "change" } });
ToggleableInputDirective.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToggleableInputDirective, factory: ToggleableInputDirective.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleableInputDirective, [{
        type: Directive
    }, {
        type: Injectable
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { _inputElement: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], indeterminate: [{
            type: Input
        }], value: [{
            type: Input
        }], change: [{
            type: Output
        }] }); })();
